import * as React from 'react';
import Link from 'next/link';
import { useParams, usePathname } from 'next/navigation';
import { storeFront } from '@/lib/utils/routeLinks';

const vendorNavLinks: { [key: string]: string }[] = [
  {
    href: '#funktionen',
    en: 'Feature',
    de: 'Funktionen',
  },
  {
    href: '#preise',
    en: 'Price',
    de: 'Preise',
  },
  {
    href: '#uber_uns',
    en: 'About Us',
    de: 'Über uns',
  },
  {
    href: '#kundenmeinungen',
    en: 'Ordering system',
    de: 'Bestellsystem',
  },
  {
    href: 'https://blog.lentho.com/faqs/',
    en: 'Support',
    de: 'Hilfe',
  },
  // {
  //   href: '#kundenmeinungen',
  //   en: 'Testimonials',
  //   de: 'Kundenmeinungen',
  // },
  // {
  //   href: '#faq',
  //   en: 'FAQ',
  //   de: 'FAQ',
  // },
  {
    // href: 'https://4takeaway.bitrix24.de/~cBfXY',
    href: 'https://calendly.com/4takeaway/30min',
    en: 'Free consultation',
    de: 'kostenlose Beratung',
  },
];

const HeaderNavLinks = () => {
  const params = useParams();
  const locale = params.locale as string;
  const pathname = usePathname();

  const isHotelPage = [
    storeFront.forHotels.de(),
    storeFront.forHotels.en(),
  ].some((route) => pathname === `/${locale}${route}`);

  const isCompanyPage = [
    storeFront.forCompany.de(),
    storeFront.forCompany.en(),
  ].some((route) => pathname === `/${locale}${route}`);

  if (isCompanyPage) {
    return <div className="text-secondary flex flex-col xl:flex-row"></div>;
  }

  const filteredLinks = vendorNavLinks.filter(
    (link) => !isHotelPage || link.en !== 'Ordering system'
  );

  return (
    <div className="text-secondary flex flex-col gap-y-2 text-lg lg:gap-x-[25px] lg:text-[15px]/[1.3] xl:flex-row xl:items-center xl:gap-x-[35px] xl:gap-y-0 xl:text-center">
      {filteredLinks.map((link) => (
        <Link
          key={link.href}
          href={link.href}
          target={link.href.includes('http') ? '_blank' : '_self'}
          className={'transition-colors hover:text-primary-700'}
        >
          {link[locale.slice(0, 2)]}
        </Link>
      ))}
    </div>
  );
};

export default HeaderNavLinks;
